
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotel/review",
      function () {
        return require("private-next-pages/hotel/review/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotel/review"])
      });
    }
  